import classes from './Pics.module.css'
import {React, useEffect, useMemo, useRef, useState} from "react";
import axios from "axios";
import { path, buildMediaUrlForStoredPath } from "../../../routes";
import { CircularProgress } from "@mui/material";

const Pics = (props) =>{
    const [currentIndexA, setCurrentIndexA] = useState(0);
    const [cards, setCards] = useState([])
    const [isLoading, setIsLoading] = useState(false);
    const requestIdRef = useRef(0);

    const enableManualNav = props.enableManualNav === true;
    const enableZoom = props.enableZoom === true;
    const enableFullscreen = props.enableFullscreen === true;
    const maxImages = Number.isFinite(Number(props.maxImages)) ? Number(props.maxImages) : null;
    const [isFullscreen, setIsFullscreen] = useState(false);

    const staticImages = Array.isArray(props.images) ? props.images : null;
    const staticMode = Array.isArray(staticImages) && staticImages.length > 0;
    const staticImagesKey = staticMode ? staticImages.join('|') : '';

    const [zoom, setZoom] = useState(1);
    const [pan, setPan] = useState({ x: 0, y: 0 });
    const panRef = useRef({ x: 0, y: 0 });
    const [isPanning, setIsPanning] = useState(false);
    const pointerStartRef = useRef(null);

    const setObje = (x) => {
        let fld = []
        for (let i = 0; i < x.length; i++) {
            const id = x[i].id
            try {
                let temp = {
                    id: id,
                    Header: x[i].description,
                    CreatedBy: x[i].username,
                    Body: {
                        file: x[i].path,
                        //imgURL: `https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_272x92dp.png`,//fileContent,
                        imgURL: buildMediaUrlForStoredPath(x[i].path)
                    }
                }
                fld.push(temp)
            } catch (error) {
                console.error('Fetching elevators Error:', error.message);
            }
        }
        setCards([...fld])
    }

    const fetchDataCards = async (gr) => {
        const requestId = ++requestIdRef.current;
        try {
            setIsLoading(true);
            const fallbackOrgId = 'AC44260C-8496-4F02-9ECA-2B19F3C32726';
            const orgId = props.orgID || fallbackOrgId;
            const response = await axios.get(
                // onlyVisible=1 => admin "hide"/delete se projeví v kiosku
                `${path}/getCardsV3?orgID=${encodeURIComponent(orgId)}&group=${gr}&onlyVisible=1`
            );
            // Optionally, update your UI to reflect the deletion
            if (requestId !== requestIdRef.current) return;
            setObje(response.data)
        } catch (error) {
            console.error('Error deleting row:', error);
        } finally {
            if (requestId === requestIdRef.current) setIsLoading(false);
        }
    }

    const groupIDs = Array.isArray(props.groupIDs) && props.groupIDs.length > 0
        ? props.groupIDs
        : (props.groupID != null ? [props.groupID] : []);

    const startGroupID = props.startGroupID != null
        ? props.startGroupID
        : (props.groupID != null ? props.groupID : groupIDs[0]);

    const [activeGroupIndex, setActiveGroupIndex] = useState(() => {
        const idx = groupIDs.indexOf(startGroupID);
        return idx >= 0 ? idx : 0;
    });

    const activeGroupID = groupIDs[activeGroupIndex];

    const visibleCards = useMemo(() => {
        if (!Array.isArray(cards)) return [];
        if (!maxImages || maxImages < 1) return cards;
        return cards.slice(0, maxImages);
    }, [cards, maxImages]);
    const cardsLen = visibleCards.length;

    // Static mode: renderuj jen předané URL (žádné API/DB volání).
    useEffect(() => {
        if (!staticMode) return;
        const urls = Array.isArray(staticImages) ? staticImages.filter(Boolean) : [];
        const mapped = urls.slice(0, maxImages || undefined).map((url, i) => ({
            id: i,
            Header: '',
            CreatedBy: '',
            Body: {
                file: url,
                imgURL: url,
            },
        }));
        setCards(mapped);
        setCurrentIndexA(0);
        setIsLoading(false);
        setIsFullscreen(false);
        // reset zoom/pan
        setZoom(1);
        setPan({ x: 0, y: 0 });
        panRef.current = { x: 0, y: 0 };
        setIsPanning(false);
        pointerStartRef.current = null;
    }, [staticMode, staticImagesKey, maxImages]);

    // Reset slideshow index when switching groups.
    useEffect(() => {
        setCurrentIndexA(0);
        resetZoomAndPan();
    }, [activeGroupIndex]);

    // When kiosk switches category / startGroupID, align activeGroupIndex.
    useEffect(() => {
        if (startGroupID == null) return;
        const idx = groupIDs.indexOf(startGroupID);
        setActiveGroupIndex(idx >= 0 ? idx : 0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(groupIDs), startGroupID]);

    // Fetch cards for currently active group.
    useEffect(() => {
        if (activeGroupID == null) return;
        if (staticMode) return;
        let cancelled = false;

        const run = async () => {
            if (cancelled) return;
            await fetchDataCards(activeGroupID);
        };

        // load immediately + refresh periodically (so newly uploaded images appear)
        run();
        const refreshId = setInterval(run, 3000); // near-realtime

        const onVis = () => {
            if (document.visibilityState === 'visible') run();
        };
        document.addEventListener('visibilitychange', onVis);

        return () => {
            cancelled = true;
            clearInterval(refreshId);
            document.removeEventListener('visibilitychange', onVis);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeGroupID, props.orgID]);

    // Rotate through cards; when the last card is reached, advance to next group.
    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentIndexA((prevIndex) => {
                // If current group has 0/1 cards, we still must advance groups
                // (otherwise the slideshow gets stuck on the first empty/mono group).
                if (!cards || cardsLen <= 1) {
                    // Solo group (groupIDs.length == 1): nic nepřepínat, jen zůstat na 0.
                    if (groupIDs.length > 1) {
                        setActiveGroupIndex((prevGroupIndex) => (prevGroupIndex + 1) % groupIDs.length);
                    }
                    return 0;
                }

                const nextIndex = prevIndex + 1;
                if (nextIndex >= cardsLen) {
                    // Pokud máme víc groupů, po dojetí karet přepni group,
                    // jinak zůstaň v rámci jedné group.
                    if (groupIDs.length > 1) {
                        setActiveGroupIndex((prevGroupIndex) => (prevGroupIndex + 1) % groupIDs.length);
                    }
                    return 0;
                }

                return nextIndex;
            });
        }, 15000);
        return () => clearInterval(intervalId);
    }, [cardsLen, groupIDs.length]);

    const goPrev = () => {
        if (cardsLen <= 1) return;
        setCurrentIndexA((prev) => (prev - 1 + cardsLen) % cardsLen);
    };

    const goNext = () => {
        if (cardsLen <= 1) return;
        setCurrentIndexA((prev) => (prev + 1) % cardsLen);
    };

    const resetZoomAndPan = () => {
        setZoom(1);
        setPan({ x: 0, y: 0 });
        panRef.current = { x: 0, y: 0 };
        setIsPanning(false);
        pointerStartRef.current = null;
    };

    const onToggleZoom = () => {
        if (!enableZoom) return;
        if (zoom <= 1.01) {
            setZoom(2.2);
            setPan({ x: 0, y: 0 });
            panRef.current = { x: 0, y: 0 };
        } else {
            resetZoomAndPan();
        }
    };

    const onWheel = (e) => {
        if (!enableZoom) return;
        e.preventDefault();
        const dir = e.deltaY < 0 ? 1 : -1;
        const next = Math.max(1, Math.min(3, zoom + dir * 0.15));
        if (next <= 1.01) {
            resetZoomAndPan();
            return;
        }
        setZoom(next);
    };

    const onPointerDown = (e) => {
        if (!enableZoom) return;
        if (zoom <= 1.01) return;
        e.preventDefault();
        pointerStartRef.current = {
            x: e.clientX,
            y: e.clientY,
            panX: panRef.current.x,
            panY: panRef.current.y,
        };
        setIsPanning(true);
    };

    const onPointerMove = (e) => {
        if (!enableZoom) return;
        if (!isPanning) return;
        if (!pointerStartRef.current) return;
        const dx = e.clientX - pointerStartRef.current.x;
        const dy = e.clientY - pointerStartRef.current.y;
        const nextPan = { x: pointerStartRef.current.panX + dx, y: pointerStartRef.current.panY + dy };
        panRef.current = nextPan;
        setPan(nextPan);
    };

    const onPointerUp = () => {
        if (!enableZoom) return;
        setIsPanning(false);
        pointerStartRef.current = null;
    };

    // swipe (přepínání obrázků) - jen když nejsme zoomovaní
    const touchStartXRef = useRef(null);
    const touchStartYRef = useRef(null);
    const onTouchStart = (e) => {
        if (!enableManualNav) return;
        if (enableZoom && zoom > 1.01) return;
        const t = e.touches?.[0];
        touchStartXRef.current = t?.clientX ?? null;
        touchStartYRef.current = t?.clientY ?? null;
    };
    const onTouchEnd = (e) => {
        if (!enableManualNav) return;
        if (enableZoom && zoom > 1.01) return;
        const t = e.changedTouches?.[0];
        const sx = touchStartXRef.current;
        const sy = touchStartYRef.current;
        touchStartXRef.current = null;
        touchStartYRef.current = null;
        if (sx == null || sy == null || !t) return;
        const dx = t.clientX - sx;
        const dy = t.clientY - sy;
        if (Math.abs(dx) < 50) return;
        if (Math.abs(dy) > 60) return;
        if (dx < 0) goNext();
        else goPrev();
    };

    // Let parent know current visible image (for footer/banner).
    useEffect(() => {
        if (typeof props.onImageChange !== 'function') return;
        const url = visibleCards[currentIndexA]?.Body?.imgURL;
        if (url) props.onImageChange(url);
    }, [visibleCards, currentIndexA, props.onImageChange]);

    useEffect(() => {
        if (currentIndexA >= cardsLen) setCurrentIndexA(0);
    }, [cardsLen, currentIndexA]);

    return <div className={classes.main}>
        {cardsLen > 0 ? (
            <div
                className={classes.prev}
                style={{ position: 'relative', width: '100%', height: '100%' }}
                onWheel={onWheel}
                onTouchStart={onTouchStart}
                onTouchEnd={onTouchEnd}
            >
                <img
                    className={classes.imageRed}
                    src={visibleCards[currentIndexA]?.Body?.imgURL}
                    alt={"logo"}
                    onClick={(e) => {
                        if (enableFullscreen) {
                            e.stopPropagation();
                            setIsFullscreen(true);
                            return;
                        }
                        onToggleZoom();
                    }}
                    onPointerDown={onPointerDown}
                    onPointerMove={onPointerMove}
                    onPointerUp={onPointerUp}
                    onPointerCancel={onPointerUp}
                    draggable={false}
                    style={{
                        transform:
                            enableZoom
                                ? `translate(${pan.x}px, ${pan.y}px) scale(${zoom})`
                                : 'none',
                        cursor:
                            enableZoom
                                ? (zoom > 1.01 ? (isPanning ? 'grabbing' : 'grab') : 'zoom-in')
                                : 'default',
                    }}
                />

                {enableManualNav && cardsLen > 1 && (
                    <>
                        <button
                            type="button"
                            aria-label="previous"
                            onClick={goPrev}
                            style={{
                                position: 'absolute',
                                left: 8,
                                top: '50%',
                                transform: 'translateY(-50%)',
                                zIndex: 3,
                                width: 40,
                                height: 40,
                                borderRadius: 20,
                                border: '1px solid rgba(255,255,255,0.55)',
                                background: 'rgba(0,0,0,0.35)',
                                color: '#fff',
                                cursor: 'pointer',
                            }}
                        >
                            ‹
                        </button>
                        <button
                            type="button"
                            aria-label="next"
                            onClick={goNext}
                            style={{
                                position: 'absolute',
                                right: 8,
                                top: '50%',
                                transform: 'translateY(-50%)',
                                zIndex: 3,
                                width: 40,
                                height: 40,
                                borderRadius: 20,
                                border: '1px solid rgba(255,255,255,0.55)',
                                background: 'rgba(0,0,0,0.35)',
                                color: '#fff',
                                cursor: 'pointer',
                            }}
                        >
                            ›
                        </button>
                    </>
                )}
            </div>
        ) : (
            <div className={classes.prev}>
                {isLoading ? <CircularProgress color="inherit" size={80} /> : null}
            </div>
        )}

        {enableFullscreen && isFullscreen && cardsLen > 0 && (
            <div
                style={{
                    position: 'fixed',
                    inset: 0,
                    zIndex: 2000,
                    background: 'rgba(0,0,0,0.92)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
                onClick={() => setIsFullscreen(false)}
            >
                <button
                    type="button"
                    onClick={(e) => {
                        e.stopPropagation();
                        setIsFullscreen(false);
                    }}
                    style={{
                        position: 'absolute',
                        top: 16,
                        right: 16,
                        zIndex: 2002,
                        border: '1px solid rgba(255,255,255,0.7)',
                        background: 'rgba(0,0,0,0.35)',
                        color: '#fff',
                        borderRadius: 8,
                        padding: '10px 14px',
                        cursor: 'pointer',
                        fontWeight: 700,
                    }}
                >
                    Close
                </button>
                {enableManualNav && cardsLen > 1 && (
                    <>
                        <button
                            type="button"
                            aria-label="previous fullscreen"
                            onClick={(e) => {
                                e.stopPropagation();
                                goPrev();
                            }}
                            style={{
                                position: 'absolute',
                                left: 16,
                                top: '50%',
                                transform: 'translateY(-50%)',
                                zIndex: 2002,
                                width: 52,
                                height: 52,
                                borderRadius: 26,
                                border: '1px solid rgba(255,255,255,0.7)',
                                background: 'rgba(0,0,0,0.35)',
                                color: '#fff',
                                cursor: 'pointer',
                                fontSize: 28,
                            }}
                        >
                            ‹
                        </button>
                        <button
                            type="button"
                            aria-label="next fullscreen"
                            onClick={(e) => {
                                e.stopPropagation();
                                goNext();
                            }}
                            style={{
                                position: 'absolute',
                                right: 16,
                                top: '50%',
                                transform: 'translateY(-50%)',
                                zIndex: 2002,
                                width: 52,
                                height: 52,
                                borderRadius: 26,
                                border: '1px solid rgba(255,255,255,0.7)',
                                background: 'rgba(0,0,0,0.35)',
                                color: '#fff',
                                cursor: 'pointer',
                                fontSize: 28,
                            }}
                        >
                            ›
                        </button>
                    </>
                )}
                <img
                    src={visibleCards[currentIndexA]?.Body?.imgURL}
                    alt=""
                    style={{
                        maxWidth: '96vw',
                        maxHeight: '96vh',
                        objectFit: 'contain',
                    }}
                    onClick={(e) => e.stopPropagation()}
                />
            </div>
        )}

    </div>
}
export default Pics